var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPay2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 23,
    viewBox: "166 0 63 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.931 19.0377V10.0943H180.536L177.703 19.0377H174.338H174.328L171.504 10.0943H171.112V19.0377H166.28V3.98444H171.119C171.722 3.9816 172.311 4.17296 172.797 4.53016C173.283 4.88728 173.641 5.39138 173.819 5.96792L175.808 12.9252H176.226L178.219 5.96792C178.398 5.39032 178.757 4.8856 179.245 4.52839C179.733 4.17119 180.323 3.98045 180.927 3.98444H185.767V19.0377H180.927H180.931Z",
    fill: "#2C3038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.44 19.0376V10.173H199.059L195.758 17.5996C195.564 18.0287 195.251 18.3926 194.855 18.6477C194.458 18.9027 193.998 19.0381 193.527 19.0376H189.298V3.98438H194.168V12.849H194.567L197.909 5.41089C197.918 5.3923 197.926 5.37281 197.935 5.35422V5.34891C198.137 4.93875 198.45 4.5935 198.839 4.35229C199.227 4.11109 199.676 3.98367 200.133 3.98438H204.362V19.0376H199.44Z",
    fill: "#2C3038"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.641 14.6174H212.839V19.0377H207.914V11.0684H224.279C223.791 12.1476 222.996 13.0595 221.994 13.6905C220.991 14.3214 219.825 14.6439 218.641 14.6174Z",
    fill: "#2C3038"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.589 9.29728H215.228C211.163 9.29728 207.783 6.84272 207.071 3.98438H219.079C222.188 3.98438 224.707 6.13876 224.707 8.44279C224.707 8.73172 224.668 9.01924 224.589 9.29728Z",
    fill: "#2C3038"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPay2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pay2.ed06a4ad87b158da51208bcda3716170.svg";